import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { CacheInvalidationRealtimeService } from '../services/cache-invalidation-realtime.service';

/**
 * `CacheInvalidationRealtimeService` é `providedIn: 'root'`, mas só é
 * instanciado quando algo o injeta — nenhum componente depende dele
 * diretamente (seu trabalho é todo em `constructor`/`effect`). Este
 * initializer força a instanciação cedo, no bootstrap.
 */
export function provideCacheInvalidation(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(CacheInvalidationRealtimeService);
  });
}
